const IN_APP_BROWSER_PATTERNS = [
    'FBAN', // Facebook
    'FBAV', // Facebook
    'Instagram',
    'Twitter',
    'LinkedInApp',
    'BytedanceWebview',
    'TikTok',
    'Snapchat',
    'Pinterest',
    'Line/',
    'KAKAOTALK',
    'Telegram',
    'Reddit/',
    'MicroMessenger', // WeChat
    'musical_ly',
]

export function isInAppBrowser(): boolean {
    if (typeof navigator === 'undefined') return false

    const ua = navigator.userAgent || ''

    if (IN_APP_BROWSER_PATTERNS.some((pattern) => ua.includes(pattern))) {
        return true
    }

    // iOS WebView detection: WKWebView doesn't contain "Safari" in the UA
    // but regular Safari and Chrome on iOS do
    const isIOS = /iPhone|iPad|iPod/.test(ua)
    const hasSafari = /Safari/.test(ua)
    const hasChrome = /CriOS/.test(ua)
    if (isIOS && !hasSafari && !hasChrome) {
        return true
    }

    return false
}

/**
 * Returns `true` if the in-app browser was intercepted (toast shown + link copied).
 * Intended as an early-return guard in OAuth handlers.
 */
export async function interceptInAppBrowser(): Promise<boolean> {
    if (!isInAppBrowser()) return false

    const appName = getInAppBrowserName()
    const label = appName ? `the ${appName} browser` : 'this in-app browser'
    await navigator.clipboard.writeText(window.location.href).catch(() => {})

    const { toast } = await import('@/features/toast/toast')
    toast.info(`Google sign-in isn't supported in ${label}. We copied the link — paste it in Safari or Chrome.`, {
        duration: 8000,
        datadog: { enabled: false },
    })

    return true
}

export function getInAppBrowserName(): string | null {
    if (typeof navigator === 'undefined') return null

    const ua = navigator.userAgent || ''

    const nameMap: [string, string][] = [
        ['Twitter', 'X'],
        ['Instagram', 'Instagram'],
        ['FBAN', 'Facebook'],
        ['FBAV', 'Facebook'],
        ['LinkedInApp', 'LinkedIn'],
        ['TikTok', 'TikTok'],
        ['BytedanceWebview', 'TikTok'],
        ['Snapchat', 'Snapchat'],
        ['Pinterest', 'Pinterest'],
        ['Reddit/', 'Reddit'],
        ['Telegram', 'Telegram'],
        ['MicroMessenger', 'WeChat'],
        ['Line/', 'LINE'],
        ['KAKAOTALK', 'KakaoTalk'],
        ['musical_ly', 'TikTok'],
    ]

    for (const [pattern, name] of nameMap) {
        if (ua.includes(pattern)) return name
    }

    return null
}
